import { For, Show, createEffect, createMemo, createSignal } from "solid-js";
import { cx } from "../../../styled-system/css";
import { imageUrl } from "../../data";
import { styles } from "../../styles";
import { coordinateOptionValue, FriendCoordinateSelect } from "./FriendCoordinateSelect";
import type { FriendCode, FriendCoordinateOption, FriendCoordinateReference } from "./types";

export function FriendCoordinateEditor(props: {
  code: FriendCode | null;
  options: FriendCoordinateOption[];
  onClose: () => void;
  onSave: (code: FriendCode, coordinate: FriendCoordinateReference) => void;
}) {
  const [coordinate, setCoordinate] = createSignal<FriendCoordinateReference>(null);
  const selectedOption = createMemo(() => {
    const value = coordinateOptionValue(coordinate());
    return value ? props.options.find((option) => coordinateOptionValue(option) === value) : undefined;
  });

  createEffect(() => {
    setCoordinate(props.code?.coordinate ?? null);
  });

  const save = () => {
    const code = props.code;
    if (!code) return;
    props.onSave(code, coordinate());
    props.onClose();
  };

  return (
    <Show when={props.code}>
      {(code) => (
        <div class={styles.previewLayer} role="presentation">
          <button class={styles.previewBackdrop} type="button" aria-label="コーデ紐付けを閉じる" onClick={props.onClose} />
          <section class={styles.friendEditorModal} role="dialog" aria-modal="true" aria-labelledby="friend-editor-title">
            <header class={styles.previewHeader}>
              <h2 id="friend-editor-title">コーデ紐付け：{code().playerName}</h2>
              <button class={styles.iconButton} type="button" aria-label="閉じる" onClick={props.onClose}>×</button>
            </header>
            <div class={styles.friendEditorBody}>
              <div class={styles.field}>
                <span class={styles.label}>コーデ</span>
                <FriendCoordinateSelect options={props.options} value={coordinate()} autofocus onChange={setCoordinate} />
              </div>
              <Show when={selectedOption()}>
                {(option) => (
                  <section class={styles.friendCoordinatePreview} aria-label={`${option().name}の構成アイテム`}>
                    <strong>{option().name}</strong>
                    <div class={styles.previewConstituentItems}>
                      <For each={option().items}>{(item) => (
                        <div class={cx(styles.previewConstituentItemButton, styles.friendCoordinatePreviewItem)}>
                          <img
                            class={cx(styles.image, styles.thumbnailImage)}
                            src={imageUrl(item.url)}
                            alt={`${item.name} ${item.term}`}
                            loading="lazy"
                            decoding="async"
                            draggable={false}
                          />
                        </div>
                      )}</For>
                    </div>
                  </section>
                )}
              </Show>
              <div class={styles.qrRegistrationActions}>
                <button class={styles.mixRegistrationButton} type="button" onClick={save}>保存</button>
                <button class={styles.secondaryButton} type="button" onClick={props.onClose}>キャンセル</button>
              </div>
            </div>
          </section>
        </div>
      )}
    </Show>
  );
}
